import { render, staticRenderFns } from "./IconAddMenuFilled.vue?vue&type=template&id=225fd4cf&scoped=true"
import script from "./IconAddMenuFilled.vue?vue&type=script&lang=js"
export * from "./IconAddMenuFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fd4cf",
  null
  
)

export default component.exports